import React from 'react';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
// import DialogTitle from '@material-ui/core/DialogTitle';
import MuiDialogTitle from '@material-ui/core/DialogTitle';
import Typography from '@material-ui/core/Typography';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import { withStyles} from "@material-ui/core";
import {BRCustomizedTooltip as Tooltip} from "../accents/BRCustomizedTooltip";
import BBIconAdd from "../../../assets/bbCustomIcons/BBIconAdd";

const styles = (theme) => ({
    root: {
        margin: 0,
        padding: theme.spacing(2),
    },
    closeButton: {
        position: 'absolute',
        right: theme.spacing(1),
        top: theme.spacing(1),
        color: theme.palette.grey[500],
    },
});

const FormDialog = (props) => {

    const {iconOnly = false, iconSize = null, formComponent = <></>, buttonLabel="Element", disabled=false} = props;

    const [open, setOpen] = React.useState(false);

    const handleClickOpen = () => {
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
    };

    const DialogTitle = withStyles(styles)((props) => {
        const { children, classes, onClose, ...other } = props;
        return (
            <MuiDialogTitle disableTypography className={classes.root} {...other}>
                <Typography variant="h6">{children}</Typography>
                {onClose ? (
                    <IconButton aria-label="close" className={classes.closeButton} onClick={onClose}>
                        <CloseIcon />
                    </IconButton>
                ) : null}
            </MuiDialogTitle>
        );
    });


    return (
        <div>
            <Tooltip title={"Add a new element of your IT infrastructure to increase your fidelity."}>
                <Button
                    id={`tourAddElementButton_${buttonLabel}`}
                    variant="outlined"
                    color="default"
                    onClick={handleClickOpen}
                    className={"text-electric-blue highlightAddITElementButton"}
                >
                    {iconOnly
                        ? <BBIconAdd style={{fontSize: "70px"}}/>
                        : <><BBIconAdd className={"mr-2"}/>New {buttonLabel}</>
                    }

                </Button>
            </Tooltip>

            <Dialog
                fullWidth={false}
                maxWidth={"xl"}
                open={open}
                onClose={handleClose}
                aria-labelledby="form-dialog-title"
            >
                <DialogTitle id="customized-dialog-title" onClose={handleClose}>
                    Add New Element
                </DialogTitle>
                {!disabled
                    ? <DialogContent>
                    <DialogContentText>
                        <p>Add a new element of your IT infrastructure to increase your fidelity.</p>
                        <p>
                            <em>
                                <small>
                                    Elements appear in technical details and reports at the conclusion of the next scoring cycle.
                                </small>
                            </em>
                        </p>
                    </DialogContentText>
                    <div className={"border-2 p-3"}>
                        {formComponent}
                    </div>

                </DialogContent>
                :<DialogContent>
                        <p>Adding IT infrastructure Elements requires manager or administrator access level permissions.</p>
                    </DialogContent>}
                <DialogActions>
                    {/*<Button onClick={handleClose} color="primary">*/}
                    {/*    Cancel*/}
                    {/*</Button>*/}
                    <Button onClick={handleClose} color="primary">
                        Done
                    </Button>
                </DialogActions>
            </Dialog>
        </div>
    );
}

export default FormDialog;
